import React from 'react';
import { observer } from 'mobx-react';
import { action, computed, observable } from 'mobx';

import './style.styl';

import { Collapse, MenuItem } from '@material-ui/core';

@observer
class MenuCollapseItem extends React.Component {
  @observable open = false;

  render() {
    const { primary, MenuItemProps } = this.props;

    return (
      <div>
        <MenuItem {...MenuItemProps} className={this.className} onClick={this.onClick}>
          <div className={'flex-both'}>{primary}</div>
          <div className={'flex-none'}>
            <i className={`fa ${this.chevron}`} />
          </div>
        </MenuItem>
        <Collapse in={this.open} timeout="auto">
          {this.props.children}
        </Collapse>
      </div>
    );
  }

  @computed
  get className() {
    let open = !!this.open ? 'open' : '';
    return `menu-collapse-item flex-row nowrap ${open}`;
  }

  @computed
  get chevron() {
    return this.open ? 'fa-chevron-up' : 'fa-chevron-down';
  }

  @action.bound
  onClick() {
    this.open = !this.open;
  }
}

export default MenuCollapseItem;
